module.exports = __webpack_public_path__ + "img/icons B_25.910aee4e.svg";